import { BaseLogDocument, LogDocumentType } from '@caballus/common';

export class LogCreateDto {
    public affectedUser: string;
    public type: LogDocumentType;
    public context: BaseLogDocument;

    constructor(params?: Partial<LogCreateDto>) {
        if (!!params) {
            this.affectedUser = params.affectedUser || this.affectedUser;
            this.type = params.type || this.type;
            this.context = params.context || this.context;
        }
    }
}
